import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostContact_questions = z.any()
export type TagsPostContact_questions = z.infer<typeof tagsPostContact_questions>

export const bodyPostContact_questions = z.object({ "email": z.string().email().min(1), "question": z.string().min(1).max(2000) })
export type BodyPostContact_questions = z.infer<typeof bodyPostContact_questions>

export const responsePostContact_questions = z.object({ "payload": z.object({ "success": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostContact_questions = z.infer<typeof responsePostContact_questions>

interface IPostContact_questions extends BaseMethodType {
  tags: TagsPostContact_questions,
  body: BodyPostContact_questions,
  response: ResponsePostContact_questions
}
export const URL = '/contact-questions'
export const validation = {
  post: {
    tags: tagsPostContact_questions,
    body: bodyPostContact_questions,
    response: responsePostContact_questions
  }
}
export interface Contact_questions extends BaseRouteType {
  post: IPostContact_questions
}